/* @jsx h */
import { defineComponent, h } from "vue";

type Props = { prices: number[] };

/** A tiny line of recent prices, oldest → newest. */
export const PriceSparkline = defineComponent<Props>({
  name: "PriceSparkline",
  props: ["prices"],
  setup(props) {
    return () => {
      const values = props.prices;
      if (values.length < 2) return <span class="text-base-content/30">—</span>;
      const width = 72;
      const height = 20;
      const min = Math.min(...values);
      const max = Math.max(...values);
      const span = max - min || 1;
      const points = values
        .map((v, i) => {
          const x = (i / (values.length - 1)) * width;
          const y = height - 2 - ((v - min) / span) * (height - 4);
          return `${x.toFixed(1)},${y.toFixed(1)}`;
        })
        .join(" ");
      const rising = values[values.length - 1] > values[0];
      return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
          <polyline
            points={points}
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            class={rising ? "text-warning" : "text-success"}
          />
        </svg>
      );
    };
  },
});
